import React from "react";
import { EditButton } from "../../../common/button/EditButton";
import { RemoveButton } from "../../../common/button/RemoveButton";

export const EditAndDeleteButton = React.memo(function EditAndDeleteButton(props: Props) {
    const {
        onEditClick,
        onDeleteClick
    } = props;

    return (
        <div className="button_area">
            <EditButton onClick={onEditClick} />
            <RemoveButton onClick={onDeleteClick} />
        </div>
    );
});

type Props = {
    onEditClick: () => void
    onDeleteClick: () => void
};
